var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-primary btn-lg btn-block",attrs:{"type":"submit"}},[_vm._v("\n        Submit\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-link btn-lg btn-block mt-3",attrs:{"type":"submit"},on:{"click":function($event){return _vm.closeModals()}}},[_vm._v("\n        Cancel\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }